import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './utils/firebase'; // Initialize Firebase
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import PatientDetail from './pages/PatientDetail';
import ChiropracticSessionView from './pages/ChiropracticSessionView';

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/patient/:id" element={<PatientDetail />} />
            <Route path="/soap-notes" element={<ChiropracticSessionView />} />
            {/* Remove the Practice Analytics route */}
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;